import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-confirm-restore-dialog',
  templateUrl: './confirm-restore-dialog.component.html',
  styleUrls: ['./confirm-restore-dialog.component.scss']
})
export class ConfirmRestoreDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfirmRestoreDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }
  onNoClick() {
    this.dialogRef.close();
  }

}
